export default __webpack_public_path__ + "static/media/element_71.a5f3e3fd.avif";